// Auto-generated queries for Progress domain — DO NOT EDIT.

import type { QueryDef } from '@voicedojo/api';
import type { MasteryProgress, PlanSummary } from './ReadModels.g.js';

export interface FindMasteryProgressByUserQuery {
}

export interface FindPlansByUserQuery {
}

/** QueryDef descriptor for POST /api/query ($type: 'FindMasteryProgressByUserQuery'). */
export const findMasteryProgressByUser: QueryDef<FindMasteryProgressByUserQuery, MasteryProgress> = {
  $type: 'FindMasteryProgressByUserQuery',
  watch: 'MasteryProgress',
};

/** QueryDef descriptor for POST /api/query ($type: 'FindPlansByUserQuery'). */
export const findPlansByUser: QueryDef<FindPlansByUserQuery, PlanSummary> = {
  $type: 'FindPlansByUserQuery',
  watch: 'PlanSummary',
};

